import { render, staticRenderFns } from "./SolarAdmin.vue?vue&type=template&id=5d789b26&scoped=true"
import script from "./SolarAdmin.vue?vue&type=script&lang=js"
export * from "./SolarAdmin.vue?vue&type=script&lang=js"
import style0 from "./SolarAdmin.vue?vue&type=style&index=0&id=5d789b26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d789b26",
  null
  
)

export default component.exports